import _slicedToArray from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState, useEffect } from 'react';
import canUseDom from '@clearscore-group/lib.helpers.can-use-dom';

/* eslint-disable react-hooks/exhaustive-deps */
function getValue(mediaQueryLists, values) {
  var index = mediaQueryLists.findIndex(function (mql) {
    return mql.matches;
  });
  if (Array.isArray(values)) {
    return typeof values[index] === 'undefined' ? values[0] : values[index];
  }
  return values;
}
function useMedia(queries, values) {
  var isBrowser = canUseDom();
  // fall back to first query if rendering on the server as window is unavailable
  var mediaQueryLists = isBrowser ? queries.map(function (q) {
    return window.matchMedia(q);
  }) : [true];
  var _useState = useState(getValue(mediaQueryLists, values)),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  function setState() {
    setValue(getValue(mediaQueryLists, values));
  }
  useEffect(function () {
    if (canUseDom()) {
      mediaQueryLists.forEach(function (mql) {
        return mql.addListener(setState);
      });
    }
    setState();
    return function () {
      if (canUseDom()) {
        mediaQueryLists.forEach(function (mql) {
          return mql.removeListener(setState);
        });
      }
    };
  }, [queries, values, isBrowser]);
  return value;
}
export default useMedia;